<template lang="pug">
v-app(id="inspire")
  RouterView
  AppNotify
  AppFaq
  AppLimits
  AppLogout
  AppSwitch
  AppDialogModal(
    :is-visible.sync="isVisible"
    :modal-padding="isMobile ? '1.5rem' : '2.5rem'"
    toolbar-height="10px"
    :max-width="isMobile ? 343 : 505"
    modal-title-icon="$sima-verification-logo"
    modalDescriptionMarginBottom="24px"
    :modal-title="$t('misc.sima.verified.with')"
    :modal-description="$t('misc.sima.verified.recommend')")
    template(#modalBody)
      div.qr-area.d-flex.align-center.justify-center(v-if="!isMobile")
        div.qr-box.sima-qr.mt-6
          img(:src="require('@/assets/app-qr-download.svg')")
      div(v-else)
        v-btn.dialog_modal_button.w-100.mt-8(id="sima_proceed" depressed color="primary" @click="goToAppSima")
          | {{ $t('misc.sima.proceed') }}
</template>

<script>
import AppNotify from '@/components/AppNotify';
import AppFaq from '@/components/AppFaq';
import AppLimits from '@/components/AppLimits';
import AppLogout from '@/components/AppLogout';
import AppSwitch from '@/components/AppSwitch';
import AppDialogModal from '@/components/AppDialogModal';
import { mapGetters } from 'vuex';

export default {
  name: 'App',
  components: {
    AppNotify,
    AppFaq,
    AppLimits,
    AppLogout,
    AppSwitch,
    AppDialogModal,
  },
  computed: {
    ...mapGetters('user', ['getUserData', 'getSimaModalStatus']),
    isVisible: {
      get() {
        return this.getSimaModalStatus;
      },
      set(value) {
        this.$store.dispatch('user/setSimaModalStatus', value);
      },
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  watch: {
    $route(to) {
      if (to.query.lang) {
        localStorage.setItem('lang', to.query.lang);
        this.$i18n.locale = to.query.lang;
      }
    },
    getUserData() {
      this.$i18n.locale = this.getUserData.language?.toLowerCase();
    },
    getSimaModalStatus() {
      this.isModalVisible = this.getSimaModalStatus;
    },
  },
  mounted() {
    // this.$i18n.locale = this.getUserData.language?.toLowerCase();
    if (process.env.VUE_APP_BACKEND_HOST === 'https://endpoint.mpay.az/api/') {
      // Inject the script for GTM
      const scriptTag = document.createElement('script');
      scriptTag.id = 'google-tag-manager';
      scriptTag.innerHTML = `
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','GTM-PL5CCG4D');
    `;
      document.head.appendChild(scriptTag);
    }
  },
  methods: {
    goToAppSima() {
      window.location.href = 'mpay://sima-verification';
      setTimeout(() => {
        window.location.href = 'https://onelink.to/mpay.yukle';
      }, 2000);
    },
  },
};
</script>
